import React, { useState } from 'react';
import { FileDownIcon, MenuIcon, ClipboardIcon, BarChart2Icon, LayersIcon, LightbulbIcon, BoxIcon, Loader2Icon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { MobileNav } from './MobileNav';
import { exportReportToPdf } from '../utils/exportPdf';
interface HeaderProps {
  timeRange: string;
  setTimeRange: (range: string) => void;
}
export const Header: React.FC<HeaderProps> = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [activeItem, setActiveItem] = useState('overview');
  const [isExporting, setIsExporting] = useState(false);
  const navItems = [{
    id: 'overview',
    label: 'Overview',
    icon: ClipboardIcon,
    section: 'overview',
    href: '#overview'
  }, {
    id: 'performance',
    label: 'Performance',
    icon: BarChart2Icon,
    section: 'performance',
    href: '#performance'
  }, {
    id: 'analysis',
    label: 'Analysis',
    icon: LayersIcon,
    section: 'analysis',
    href: '#analysis'
  }, {
    id: 'statistics',
    label: 'Statistics',
    icon: BoxIcon,
    section: 'statistics',
    href: '#statistics'
  }, {
    id: 'recommendations',
    label: 'Next Steps',
    icon: LightbulbIcon,
    section: 'recommendations',
    href: '#recommendations'
  }];
  const handleExport = async () => {
    if (isExporting) return;
    setIsExporting(true);
    try {
      await exportReportToPdf();
    } catch (err) {
      console.error('Failed to export report', err);
    } finally {
      setIsExporting(false);
    }
  };
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80; // Adjust this value based on your header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setActiveItem(sectionId);
  };
  return <header className="bg-white border-b border-[#F2F3F5] sticky top-0 z-50" data-id="element-174" data-mp="1wc4s0o54x5v1">
      <div className="w-full max-w-[1440px] mx-auto px-6 lg:px-8" data-id="element-175" data-mp="1hmqhhcptoie2">
        <div className="flex items-center justify-between h-16 relative" data-id="element-176" data-mp="1mml7zf5or5yl">
          <div className="flex items-center h-full w-48 lg:w-56" data-id="element-177" data-mp="1mki69xv67oe1">
            <div className="absolute top-0 left-0 bg-white border-b border-r border-[#F2F3F5] p-4 h-16 w-48 lg:w-56 flex items-center justify-center z-50" data-id="element-178" data-mp="18maaht9vet4g">
              <div className="flex flex-col items-start leading-none" data-id="element-179" data-mp="yp5phwrrh3p8">
                <span className="text-[#003B64] font-bold text-xl tracking-tight italic" data-id="element-180" data-mp="yr8p98ipub75">
                  Lagardère
                </span>
                <span className="text-[#D1005D] font-semibold text-[10px] tracking-widest uppercase" data-id="element-181" data-mp="2t2nfdqfn2cnf">
                  TRAVEL RETAIL
                </span>
              </div>
            </div>
          </div>
          <nav className="hidden md:flex items-center space-x-1 pl-4" data-id="element-182" data-mp="mfptg98azukk">
            {navItems.map(item => {
            const Icon = item.icon;
            return <a key={item.id} href={item.href} onClick={e => {
              e.preventDefault();
              scrollToSection(item.section);
            }} className={`flex items-center px-3 py-1.5 rounded-sm text-sm transition-colors ${activeItem === item.section ? 'bg-[#D1005D]/5 text-[#D1005D]' : 'text-[#707070] hover:bg-gray-50'}`} data-id="element-183" data-mp="w47riip77nki">
                  <Icon className="h-4 w-4 mr-2" data-id="element-184" data-mp="1f2tu620d5mqj" />
                  {item.label}
                </a>;
          })}
          </nav>
          <div className="flex items-center space-x-2" data-id="element-185" data-mp="3guf7o6rf8drz">
            <button onClick={handleExport} disabled={isExporting} className="hidden md:flex items-center space-x-2 bg-white border border-[#003B64] text-[#003B64] px-4 py-2 rounded-sm font-medium hover:bg-[#003B64]/5 transition-colors disabled:opacity-60 disabled:cursor-not-allowed" data-id="element-186" data-mp="3guyrjt0mtc8n">
              {isExporting ? <Loader2Icon className="h-4 w-4 animate-spin" data-id="element-187" data-mp="2cxweydsjw804" /> : <FileDownIcon className="h-4 w-4" data-id="element-188" data-mp="2gyq2h622zksh" />}
              <span data-id="element-189" data-mp="2gw3skzrpwt73">{isExporting ? 'Preparing…' : 'Export'}</span>
            </button>
            <a href="#" className="hidden md:block bg-[#D1005D] text-white px-4 py-2 rounded-sm font-medium hover:bg-[#D1005D]/90 transition-colors whitespace-nowrap" data-id="element-190" data-mp="1k62zwpo89ski">
              Create new
            </a>
            <button onClick={() => setIsMobileNavOpen(true)} className="md:hidden p-2 hover:bg-gray-50 rounded-none" data-id="element-191" data-mp="1xzu6pqakqycj">
              <MenuIcon className="h-5 w-5 text-gray-600" data-id="element-192" data-mp="11fv8h4tw4qk5" />
            </button>
          </div>
        </div>
      </div>
      <MobileNav isOpen={isMobileNavOpen} onClose={() => setIsMobileNavOpen(false)} navItems={navItems} activeItem={activeItem} onExport={handleExport} isExporting={isExporting} setActiveItem={id => {
      setActiveItem(id);
      scrollToSection(id);
    }} data-id="element-193" data-mp="xzigiyz6uhxg" />
    </header>;
};